import {defineMessages} from 'react-intl';

export default defineMessages({
	quickSearchTitle: {
		id: 'header.quick.search.title',
		defaultMessage: 'Search',
	},
});
